import { useEffect, useState } from "react";
import mcLogo from "../../assets/molecular-connections-logo.png";
import LocalStorageService from "../../utils/auth_service/AuthServiceStorage";
import { useMatch, useNavigate, useLocation } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { APPLICATION_NAME } from "../../utils/Constant";

const Header = () => {
  const localStorageService = LocalStorageService.getService();
  const navigate = useNavigate();
  const [username , setUername] = useState(null);

  useEffect(()=>{
    const auth = localStorageService.getAuthDetails();
    if(auth) {
      const authDetail = JSON.parse(auth);
      setUername(authDetail.username);
    }
  },[])
  const handleLogout = () => {
    localStorageService.removeTokens();
    setUername(null)
    navigate(`/${APPLICATION_NAME}/login`);
  };
  
  
 
  return (
    <>
      <div className="d-flex justify-content-between align-items-center header bg-dark">
        <img className="mx-3 my-2" src={mcLogo} alt="Molecular Connection" />
        {username && (
        //   <button className="btn btn-secondary me-3" onClick={handleLogout}>
        //   Logout
        // </button>
        <Dropdown className="me-4">
                <Dropdown.Toggle variant="light" size="sm" id="dropdown-basic">
                <i class="bi bi-person-circle"></i>
                  <span className="ml-2"> Welcome, {username}</span>{" "}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                <Dropdown.Item as="button" onClick={() => handleLogout()}>
                <i class="bi bi-box-arrow-right"></i>
                    <span className="ml-2"> Logout</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
        )

        }

        
      </div>
 
      <hr className="m-0" />
    </>
  );
};
 
export default Header;
 
 